
export const serverCreateCheckbook= (url, cedule, amount, date, serie, imei, emited, emitidor, email, description) => () => {
    let token = localStorage["feathers-jwt"]
    let urlSend = `${url}?cedule=${cedule}&amount=${amount}&date=${date}&serie=${serie}&imei=${imei}&emited=${emited}&emitidor=${emitidor}&email=${email}&description=${description}`
    // console.log('serverCreateCheckbook ', urlSend)
    return fetch(urlSend, {
      method: 'GET',
      headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
    }).then(v => v.json())
    .then(r => {
        // console.log('se obtiene ', r)
        if (r.message) {
          return Promise.reject(r.validation);
        }
        return r
    });
}


export const serverGetCheckbook = (url, field, charge) => () => {
  let token = localStorage["feathers-jwt"]
  let urlSend = `${url}?${field}=${charge}&$limit=2000&$sort[createdAt]=-1`
  // console.log('serverGetCheckbook ', urlSend)
  return fetch(urlSend, {
    method: 'GET',
    headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
  }).then(v => v.json())
  .then(r => {
      // console.log('se obtiene ', r)
      if (r.message) {
        return Promise.reject(r.validation);
      }
      return r.data
  });
}


export const serverGetCheckCharge = (url, cedule, amount, date, serie, imei, emited, emite, email, description) => () => {
  let token = localStorage["feathers-jwt"]
  let urlSend = `${url}?cedule=${cedule}&amount=${amount}&date=${date}&serie=${serie}&imei=${imei}&emited=${emited}&emite=${emite}&email=${email}&description=${description}`
  // console.log('serverGetCheckbook ', urlSend)
  return fetch(urlSend, {
    method: 'GET',
    headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
  }).then(v => v.json())
  .then(r => {
      // console.log('se obtiene ', r)
      if (r.message) {
        return Promise.reject(r.validation);
      }
      return r
  });
}


export const serverSetEndorse = (url, cedule, amount, date, serie, imei, emited, emite, email, description, image) => () => {
  let token = localStorage["feathers-jwt"]
  let urlSend = `${url}?cedule=${cedule}&amount=${amount}&date=${date}&serie=${serie}&imei=${imei}&emited=${emited}&emite=${emite}&email=${email}&description=${description}&image=${image}`
  // console.log('serverGetCheckbook ', urlSend)
  return fetch(urlSend, {
    method: 'GET',
    headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
  }).then(v => v.json())
  .then(r => {
      // console.log('se obtiene ', r)
      if (r.message) {
        return Promise.reject(r.validation);
      }
      return r
  });
}